import { css } from '@lastbrand/web-ui-styled-system/css'
import { useTranslation } from 'next-i18next'
import React from 'react'

import { getCutoffTime } from '@src/quince-site-common/src/hooks/edd/utils/edd.utils'

const orderCutoffTimeClass = css({
  color: 'mediumgray',
  textStyle: 'body-14',
  lineHeight: '16px', // legacy 1.6rem
  fontFeatureSettings: "'liga' off, 'clig' off",
})

interface OrderCutoffTimeDSProps {
  cutoffDate: number
}

/**
 * DS twin of the legacy OrderCutoffTime. Reuses getCutoffTime verbatim and the
 * same 'edd' i18n keyprefix. Renders nothing once the cutoff has expired.
 */
export function OrderCutoffTimeDS({ cutoffDate }: OrderCutoffTimeDSProps) {
  const { t } = useTranslation('common', { keyPrefix: 'edd' })

  const label = getCutoffTime(cutoffDate, t)

  if (!label) {
    return null
  }

  return (
    <div data-testid="order-cutoff-time" className={orderCutoffTimeClass}>
      {label}
    </div>
  )
}

export default OrderCutoffTimeDS
